import baseService from './baseService';

export function getCurrentStep() {
  return baseService.get('/users/current_step');
}
